import React from "react";

import { Card } from "../Card";

import { LoadingLines } from "./LoadingLines";

/**
 * Props for the LoadingCard component
 */
export interface LoadingCardProps {
  /**
   * Width of the element. Default: random width between 80 and 20%
   */
  width?: string;

  /**
   * Height of the element. Default: 1em
   */
  height?: string;

  /**
   * Number of lines to render in the card. Default: 0
   */
  lines?: number;
}

/**
 * Show a temporary loading card
 */
export function LoadingCard({
  height = "",
  width = "",
  lines = 0,
  ...props
}: LoadingCardProps): React.ReactElement {
  return (
    <Card
      aria-busy="true"
      aria-live="polite"
      style={{ height, width, marginBottom: "2rem" }}
      {...props}
    >
      <span className="screen-reader-only">Loading</span>
      <LoadingLines num={lines} />
    </Card>
  );
}
